import React from 'react';
import './stiluri/RezultateCautare.css';

const RezultateCautare = ({ searchResults, handleResultClick }) => {
  const esteDecedat = (datadeces) => {
    if (!datadeces) return false;
    const data = new Date(datadeces);
    const azi = new Date();
    return data < azi;
  };

  return (
    <div className="container-beneficiar">
      <h2>Rezultatele Căutării</h2>

      {searchResults.length > 0 && (
          <div className="tabel-scroll">

        <table
          className="table table-bordered table-hover table-sm"
          aria-labelledby="rezultate-cautare"
        >
          <thead className="thead-dark">
            <tr>
                            <th>CNP</th>
              <th>Nume</th>
              <th>Prenume</th>
              <th>Data Nașterii</th>


            </tr>
          </thead>
          <tbody>
            {searchResults.map((result, index) => {
              const esteMort = esteDecedat(result.datadeces);

              return (
                <tr
                
                  key={index}
                  className={esteMort ? 'decedat' : ''}
                  title={esteMort ? 'Persoană decedată' : ''}
                >
                                    <td onClick={() => handleResultClick(result.id)}>{result.cnp}</td>

                  <td onClick={() => handleResultClick(result.id)}>
                    {result.nume} {esteMort ? '🕯️' : ''}
                  </td>
                  <td onClick={() => handleResultClick(result.id)}>
                    {result.prenume} {esteMort ? '🕯️' : ''}
                  </td>
<td onClick={() => handleResultClick(result.id)}>
  {result.data_nasterii
    ? `${result.data_nasterii.split("-")[2]}.${result.data_nasterii.split("-")[1]}.${result.data_nasterii.split("-")[0]}`
    : ""}
  {esteMort ? ' 🕯️' : ''}
</td>


                </tr>
              );
            })}
          </tbody>
        </table>
          </div>

      )}
    </div>
  );
};

export default RezultateCautare;
